<template>
  <el-card class="box-card">
    <el-form
      :model="ruleForm"
      status-icon
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
      size="mini"
    >
      <el-form-item label="团队名称" prop="name">
        <el-input v-model="ruleForm.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="团队头像" prop="avator">
        <div class="avatar-uploader">
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </div>
        <div class="form-item">
          <input
            id="fileInput"
            type="file"
            name="file"
            accept="image/gif,image/jpeg,image/jpg,image/png,image/svg"
            @change="upload($event)"
          />
          <label for="fileInput" class="file-btn">点击上传</label>
        </div>
      </el-form-item>
      <el-form-item label="团队介绍">
        <el-input
          type="textarea"
          v-model="ruleForm.introduce"
          :autosize="{ minRows: 5, maxRows: 8}"
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item style="textAlign: center">
        <el-button style="
            width: 120px;
            height: 30px;
            background: #FE2C55;
            borderRadius: 4px;
            color:#FFFFFF;
        " type="danger" @click="submitForm()">确认</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>// @ts-nocheck
import { manageUpload } from '@/api/manage.js';
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        avator: "",
        introduce: "",
      },
      rules: {
        name: [{ required: true, message: "请输入团长名称", trigger: "blur" }],
        avator: [
          { required: true, message: "请选择团队头像", trigger: "blur" },
        ],
      },
      imageUrl:'', // 图片地址
    };
  },
  methods: {
    upload:function(e){
      // 图片显示
      var that = this;
      var imgObj = e.target.files[0];
      this.src=imgObj;
      var formData = new FormData();
      formData.append('file', this.src);
      formData.append('uid', '1');
      manageUpload(formData).then(res=>{
        if(res.code == 800){
          this.imageUrl = res.data.images;
          this.ruleForm.avator = res.data.images;
        }else{
          // handle error
        }
      })
    },
    submitForm() {
      this.$refs['ruleForm'].validate( (valid) => {
        if(valid){
          
        }
      } )
    },
  },
};
</script>

<style lang="scss" scoped>
.box-card {
  height: 650px;
  .demo-ruleForm {
    width: 500px;
  }
}

.avatar-uploader {
  width: 100px;
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}

/deep/.el-form-item__label {
  text-align: center;
}
/deep/.el-dialog__header {
  border-bottom: solid 1px #e6e7eb;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  // margin-bottom: 20px;
}

.form-item label {
  text-align: right;
  margin-top: 12px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  background: #fcebee;
  border: 1px solid #fc7e97;
  border-radius: 4px;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-left: 18px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 60px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  width: 100px;
  height: 20px;
  line-height: 20px;
  position: relative;
  text-align: center !important;
  background: #fcebee;
  border: 1px solid #fc7e97;
  border-radius: 4px;
  color: #fe2c55;
  cursor: pointer;
  font-size: 12px;
  top: 0;
  left: 0;
  margin-left: 0px;
  margin-right: 10px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>